export default __webpack_public_path__ + "static/media/etachrom.aa180ba6.png";